import React from "react";
import { Box, Typography } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import Tooltip from "@mui/material/Tooltip";
import docChecked from "../../../assets/workingDocIcons/docChecked.svg";
import { RELEASE_DOCUMENT, RELEASE_DOCUMENT_TOOLTIP } from "../../../redux/constants/labelText";
import { useTheme } from "../../../theme/OAS365Theme";

/**
 * Release document checkbox with label and icon for check-in new revision.
 */
function ReleaseDocumentCheckbox({ checked, onChange }) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        mt: "10px",
        paddingLeft: "5px",
        paddingRight: "16px",
        height: "43px",
        backgroundColor: "#E6F4EA",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "-webkit-fill-available",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Checkbox
          checked={checked}
          onChange={onChange}
          sx={{
            color: "#4c8d6a",
            "&.Mui-checked": { color: "#4c8d6a" },
          }}
        />
        <Tooltip title={RELEASE_DOCUMENT_TOOLTIP} placement="top" arrow>
          <Typography
            sx={{
              color: "#4c8d6a",
              fontWeight: "bold",
              fontFamily: theme.fonts.regular,
              fontSize: `${theme.fontSizes?.normal ?? 12}px`,
              cursor: "default",
            }}
          >
            {RELEASE_DOCUMENT}
          </Typography>
        </Tooltip>
      </Box>
      <Box component="img" src={docChecked} alt="icon" sx={{ width: 25, height: 25 }} />
    </Box>
  );
}

export default ReleaseDocumentCheckbox;
